import { Box, Grid, Typography } from '@mui/material'
import React from 'react'

interface IFormSectionText {
  message: string
}

const FormSectionText: React.FC<IFormSectionText> = ({ message }) => {
  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
      <Box sx={{ marginTop: '0.5rem', marginBottom: '1.25rem' }}>
        <Typography
          sx={{ fontFamily: 'Nunito', fontWeight: 'bold', fontSize: '1rem', lineHeight: '1.25rem' }}
        >
          {message}
        </Typography>
      </Box>
    </Grid>
  )
}

export default FormSectionText
